import { z } from "zod";

export const DocusealTimeStampSchema = z.string().datetime(); // ISO 8601 format

export const DocusealSubmitterStatusSchema = z.enum([
  "pending",
  "sent",
  "opened",
  "completed",
  "declined",
]);

export const DocusealFormEventTypeSchema = z.enum([
  "form.viewed",
  "form.started",
  "form.completed",
  "form.declined",
]);

export const DocusealSubmissionEventTypeSchema = z.enum([
  "submission.created",
  "submission.completed",
  "submission.expired",
  "submission.archived",
]);

export const DocusealFormEventSubmissionSchema = z.object({
  id: z.number().int(),
  audit_log_url: z.string().url().optional(),
  combined_document_url: z.string().url().optional(),
  status: z.string(),
  created_at: DocusealTimeStampSchema,
});

export const DocusealFormEventPayloadDataSchema = z.object({
  id: z.number().int(), // form id (submitter id)
  email: z.string().email(),
  decline_reason: z.string().optional(),
  submission: DocusealFormEventSubmissionSchema,
  template: z.object({
    id: z.number().int(),
    name: z.string(),
    external_id: z.string().optional(),
  }),
});

export const DocusealSubmissionEventPayloadDataSchema = z.object({
  id: z.number().int(), // submission id
  name: z.string(),
  slug: z.string(),
  audit_log_url: z.string().url().optional(),
  combined_document_url: z.string().url().optional(),
  template: z.object({
    id: z.number().int(),
    name: z.string(),
    external_id: z.string().optional(),
  }),
});

export const DocusealFormEventSchema = z.object({
  event_type: DocusealFormEventTypeSchema,
  data: DocusealFormEventPayloadDataSchema,
});

export const DocusealSubmissionEventSchema = z.object({
  event_type: DocusealSubmissionEventTypeSchema,
  data: DocusealSubmissionEventPayloadDataSchema,
});

export const DocusealEventSchema = z.union([
  DocusealFormEventSchema,
  DocusealSubmissionEventSchema,
]);

export const DocusealSubmitterSchema = z.object({
  id: z.number().int(),
  email: z.string().email(),
  name: z.string(),
  role: z.string(),
  status: DocusealSubmitterStatusSchema,
  slug: z.string(),
  sent_at: DocusealTimeStampSchema,
});

export const DocusealSubmissionSchema = z.object({
  id: z.number().int(),
  template_id: z.number().int(),
  created_at: DocusealTimeStampSchema,
  submitters: DocusealSubmitterSchema.array(),
});

export const DocusealTemplateSubmitterSchema = z.object({
  uuid: z.string(),
  name: z.string(),
});

export const DocusealTemplateSchema = z.object({
  submitters: DocusealTemplateSubmitterSchema.array(),
});
